import { getTenantSlug } from '../config/api';

interface InstitutionMembership {
  institution_slug: string;
  role: string;
}

interface UploadCapableUser {
  is_admin?: boolean;
  institution_memberships?: InstitutionMembership[];
}

const INSTITUTE_ADMIN_ROLES = ['institution_admin', 'institution_sub_admin'];

/**
 * Whether the current user should see the "upload book" entry points.
 *
 * - Platform context (no tenant subdomain): everyone can upload.
 * - Tenant context: platform admins and institute admins/sub-admins always
 *   can. Normal members (students, teachers) can ONLY upload when
 *   REACT_APP_INSTITUTE_USERS_CAN_UPLOAD is 'true'. Default off so an
 *   institute's library stays curated by its admins, not flooded by student
 *   uploads.
 *
 * Backend independently enforces upload via auth + tenant resolution; this
 * helper is purely for hiding the entry points so users don't see a button
 * leading to a denied action.
 */
export function canUploadBooksHere(user: UploadCapableUser | null | undefined): boolean {
  if (!user) return false;
  if (user.is_admin) return true;
  const tenantSlug = getTenantSlug();
  if (!tenantSlug) return true;
  const isInstituteAdminHere = !!user.institution_memberships?.some(
    m => m.institution_slug === tenantSlug && INSTITUTE_ADMIN_ROLES.includes(m.role),
  );
  if (isInstituteAdminHere) return true;
  return process.env.REACT_APP_INSTITUTE_USERS_CAN_UPLOAD === 'true';
}
